// export const primaryColor = "#61DBFB"; // React Blue
export const primaryColor = '#800020'; // Burgundy